import {gsap} from "../LibrariesImport";
export default class BlockScrollingText {
	static init() {

		document.querySelectorAll(".block-scrolling-text").forEach(block => {

			const scrollingText = block.querySelectorAll(' .text');

			const width = scrollingText[0].offsetWidth;
			const multiplier = window.innerWidth > 767 ? 40 : 7.5;

			setTimeout(() => {
				gsap.to(scrollingText, {
					xPercent: -200,
					duration: (width / window.innerWidth) * multiplier,
					ease: "linear",
					repeat: -1
				});
			});


		});

	}

}
